

<!-- <div class="logo">
  <a href="/dashboard" class="simple-text logo-normal" style="text-align: center;">{{'SideMenu.Title' | translate}}</a>
</div> -->

<div class="logo" style="text-align: center; padding: 10px 0;">
  <a href="/dashboard" class="simple-text logo-normal">
    <img src="assets/img/white-logo.png" alt="Logo" style="width: 190px;">
  </a>
</div>

<div class="sidebar-wrapper scrollsection">

  <div *ngIf="ShowNavigationToClient" class="user">
    <ul class="nav">
      <li class="nav-item" routerLinkActive="active"><a routerLink="customer/dashboard" class="nav-link"> <i class="material-icons">home</i><p>{{ 'SideMenu.Dashboard' | translate}}</p></a></li>
      <li class="nav-item" routerLinkActive="active"><a routerLink="customer/stamentinvoice" class="nav-link"><i class="material-icons">balance</i><p>{{ 'modules.customer.statementAccount.title' | translate}}</p> </a></li>      
      <li class="nav-item" routerLinkActive="active"><a routerLink="customer/client" class="nav-link"><i class="material-icons">business</i><p>{{ 'SideMenu.Clients.Title' | translate}}</p> </a></li>

      <!-- <li class="nav-item" routerLinkActive="active"><a routerLink="customer/invoicepakage" class="nav-link"><i class="material-icons">snippet_folder</i><p>{{ 'modules.customer.InvoicePackage.title' | translate}}</p> </a></li>
      <li class="nav-item" routerLinkActive="active"><a routerLink="customer/internalinvoice" class="nav-link"><i class="material-icons">receipt</i><p>{{ 'modules.customer.InternalInvoice.title' | translate}}</p> </a></li>
      <li class="nav-item" routerLinkActive="active"><a routerLink="customer/memorandum" class="nav-link"><i class="material-icons">assignment</i><p>{{ 'modules.customer.Memorandum.title' | translate}}</p> </a></li> -->
    </ul>
  </div>

  <ul *ngIf="ShowNavigation" class="nav">
    <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item">
      <ng-template [ngxPermissionsOnly]="menuitem.permissions">
        <!--If is a single link-->
        <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'" class="nav-link">
          <i class="material-icons">{{menuitem.icontype}}</i>
          <p style="text-transform: none;">{{menuitem.title | translate}}</p>
        </a>
        <!--If it have a submenu-->
        <a data-toggle="collapse" href="#{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub'" (click)="updatePS()" class="nav-link">
          <i class="material-icons">{{menuitem.icontype}}</i>
          <p style="text-transform: none;">{{menuitem.title | translate}}<b class="caret"></b></p>
        </a>

        <!--Display the submenu items-->
        <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
          <ul class="nav">
            <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
              <a *ngxPermissionsOnly="childitem.permissions" [routerLink]="[menuitem.path,childitem.path]" class="nav-link pl-1 p-0 mt-0">
                <span class="sidebar-mini">{{childitem.ab | translate}}</span>
                <span class="sidebar-normal" style="text-transform: none;">{{childitem.title | translate}}</span>
              </a>
            </li>
          </ul>
        </div>
        </ng-template>
    </li>
  </ul>
</div>
